<template>
  <section
    id="contact"
    class="write-us text-center">
    <div class="container">
      <div class="heading">
        <h2 class="title-subhead">Schreiben Sie uns!</h2>
        <p class="info-caption"><span class="text-bold">Aufgrund der vielen Anfragen kann es mit unserer Antwort etwas dauern.</span><br>Wir melden uns in der Regel innerhalb <span class="text-bold">von 3 Tagen.</span> Danke für Ihr Interesse an ELSAZEIT.</p>
      </div>
      <form
        class="message-form"
        @submit.prevent="sendContactData">
        <div class="input-wrap">
          <input
            v-model="contact.name"
            :class="{'error-border': errorMessages.name}"
            :readonly="isSuccess"
            class="form-control"
            type="text"
            placeholder="Name">
          <input
            v-model="contact.email"
            :class="{'error-border': errorMessages.email}"
            :readonly="isSuccess"
            class="form-control"
            type="email"
            placeholder="E-mail">
          <textarea
            v-model="contact.message"
            :class="{'error-border': errorMessages.message}"
            :readonly="isSuccess"
            class="form-control"
            placeholder="Nachricht"/>
        </div>

        <div class="messages-box">
          <p
            v-if="isSuccess"
            class="messages-box__text messages-box__text--success"
          >
            E-Mail erfolgreich gesendet
          </p>

          <p
            v-for="(message, index) in errorMessages"
            v-else
            :key="index"
            class="messages-box__text messages-box__text--error"
          >
            {{ message[0] }}
          </p>
        </div>

        <button
          v-if="!isSuccess"
          class="btn btn-primary"
          type="submit"
        >
          Absenden
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import HelperApi from '@/api/HelperApi'

export default {
  name: 'HomeContact',
  data () {
    return {
      isSuccess: false,
      contact: {
        name: '',
        email: '',
        message: ''
      },
      errorMessages: {}
    }
  },
  methods: {
    async sendContactData () {
      try {
        await HelperApi.sendContactData(this.contact)
        this.isSuccess = true
        this.errorMessages = {}
      } catch (e) {
        this.errorMessages = e.errors
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/styles/webapp/_variables.scss";

  .error-border{
    box-shadow:inset 0px 0px 0px 1px $danger;
  }

  .messages-box{
    padding-bottom: 40px;

    &__text{
      font-size: 0.7em;
      margin:  2.5px 0;

      &--error{
        color: $danger;
      }

      &--success{
        color: $green;
      }
    }
  }

</style>
